/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppAccountUpdateBusinessProfilePathParams,
	WhatsAppAccountUpdateBusinessProfileRequest,
	WhatsAppAccountUpdateBusinessProfileResponse,
} from '../types/WhatsAppAccountUpdateBusinessProfile'
import { buildFormData } from '../utils/form-data'

/**
 * POST /organisations/:organisationId/whatsapp-account/business-profile
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAccountController.php WhatsAppAccountController::updateBusinessProfile
 */
export async function whatsAppAccountUpdateBusinessProfile(
	organisationId: WhatsAppAccountUpdateBusinessProfilePathParams['organisationId'],
	data: WhatsAppAccountUpdateBusinessProfileRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppAccountUpdateBusinessProfileResponse>> {
	return axiosInstance.post(
		`/organisations/${organisationId}/whatsapp-account/business-profile`,
		buildFormData(data),
		{ headers: { 'Content-Type': 'multipart/form-data' }, ...config },
	)
}
